import script from "./fujian.vue?vue&type=script&setup=true&lang=js"
export * from "./fujian.vue?vue&type=script&setup=true&lang=js"

import "./fujian.vue?vue&type=style&index=0&id=63ee8c04&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ee8c04"]])

export default __exports__